import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { Now } from 'temporal-luxon';
import { DayOfWeek, Locale } from '@medable/i18n-core';
import { LocaleContext } from '../../../../i18n/src';
import { Text } from '../../../../typography/src';
import { toZonedDateTime } from '../date_utils';
const startOfWeek = (locale) => {
    const weekStartsOn = locale.weekInfo.firstDay;
    const date = Now.zonedDateTimeISO();
    const diff = (date.dayOfWeek < weekStartsOn ? 7 : 0) + date.dayOfWeek - weekStartsOn;
    return date.add({ days: diff * -1 }).toPlainDate();
};
const getWeekdays = (locale) => {
    const startDate = startOfWeek(locale);
    return [0, 1, 2, 3, 4, 5, 6].map((days) => startDate.add({ days }));
};
export const CalendarHead = () => {
    const locale = new Locale(useContext(LocaleContext).toString());
    const weekdays = getWeekdays(locale);
    return (_jsx("thead", { className: 'nucleus-text-text-secondary nucleus-m-0', children: _jsx("tr", { role: 'row', children: weekdays.map((weekday) => (_jsx("th", { "aria-label": new DayOfWeek(locale, { style: 'long' }).format(toZonedDateTime(weekday)), role: 'columnheader', className: 'nucleus-font-light', children: _jsx(Text, { size: 'sm', children: new DayOfWeek(locale, { style: 'calendarBestFit' }).format(toZonedDateTime(weekday)) }) }, weekday.toString()))) }) }));
};
//# sourceMappingURL=calendar_head.js.map